import { memo } from 'react';
import { Col, Row } from 'react-bootstrap';
import {
  convertToDate,
  lineHeightStyle,
  styledComponent,
} from '../../../../../utils/helpers';
import ChiefComplainDeleteBtn from '../../chiefComplainDeleteBtn';

const Gynecology = ({
  selectedHistories,
  prescriptionItems,
  setSelectedHistories,
  isDelBtn = true,
}) => {
  let { gynecology } = selectedHistories || {};

  const clearData = (itemName) => {
    switch (itemName) {
      case 'mc':
        gynecology[itemName] = {
          regular: false,
          irregular: false,
          menopause: false,
          surgicalMenopause: false,
          note: '',
        };
        break;
      case 'mp':
      case 'mcVal':
        gynecology[itemName] = '';
        break;
      case 'mpMcVal':
        gynecology['mp'] = '';
        gynecology['mcVal'] = '';
        break;
      case 'lmp':
        gynecology[itemName] = '';
        gynecology['lmpNote'] = '';
        break;
      case 'edd':
        gynecology[itemName] = '';
        gynecology['eddNote'] = '';
        gynecology['showEdd'] = false;
        break;
      case 'maritalStatus':
        gynecology[itemName] = {
          married: false,
          unmarried: false,
        };
        break;
      case 'marriedFor':
        gynecology[itemName] = {
          years: '',
          months: '',
          days: '',
          hours: '',
        };
        break;
      case 'bilateralTubalLigation':
      case 'familyPlanning':
        gynecology[itemName] = {
          husbandAbroad: false,
          separated: false,
        };
        break;
      case 'gravida':
        gynecology[itemName] = '';
        gynecology['gravidaNote'] = '';
        break;
      case 'para':
        gynecology[itemName] = '';
        gynecology['paraNote'] = '';
        gynecology['paraFirst'] = '';
        gynecology['paraFirstSign'] = '';
        gynecology['paraSecond'] = '';
        gynecology['paraSecondSign'] = '';
        gynecology['paraThird'] = '';
        gynecology['paraThirdSign'] = '';
        gynecology['paraFourth'] = '';
        gynecology['paraFourthSign'] = '';
        gynecology['paraFifth'] = '';
        break;
      case 'ageOfLastChild':
        gynecology[itemName] = {
          years: '',
          months: '',
          days: '',
          hours: '',
          note: '',
        };
        break;
      case 'fp':
        gynecology[itemName] = '';
        gynecology['fpNote'] = '';
        break;
      default:
    }
    selectedHistories['gynecology'] = gynecology;
    setSelectedHistories({ ...selectedHistories });
  };

  const getData = (data) => {
    let result = [];
    for (let key in data) {
      if (data[key] === true) {
        result.push(key);
      }
    }
    return result;
  };

  const Title = styledComponent(
    prescriptionItems?.items?.['history']?.itemStyle || {},
  );

  const Value = styledComponent(
    prescriptionItems?.items?.['history']?.subItemStyle || {},
  );

  return (
    <div className="breast-exam-view" style={lineHeightStyle('history', prescriptionItems)}>
      {(gynecology?.mc?.regular ||
        gynecology?.mc?.irregular ||
        gynecology?.mc?.menopause ||
        gynecology?.mc?.surgicalMenopause ||
        gynecology?.mp ||
        gynecology?.mcVal ||
        gynecology?.lmp ||
        gynecology?.lmpNote ||
        gynecology?.edd ||
        gynecology?.eddNote) && <div className="">Menstrual History:</div>}
      <ul style={lineHeightStyle('history', prescriptionItems)}>
        {(gynecology?.mc?.regular ||
          gynecology?.mc?.irregular ||
          gynecology?.mc?.menopause ||
          gynecology?.mc?.surgicalMenopause ||
          gynecology?.mc?.note) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>MC:</Title>{' '}
                {gynecology?.mc?.regular && <Value>Regular</Value>}
                {gynecology?.mc?.irregular && <Value>Irregular</Value>}
                {gynecology?.mc?.menopause && <Value>Menopause</Value>}
                {gynecology?.mc?.surgicalMenopause && (
                  <Value>Surgical Menopause</Value>
                )}
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'mc'}
                isDelBtn={isDelBtn}
              />
            </div>
            <Value>
              {gynecology?.mc?.note && (
                <div className="pl-4 font-italic">
                  {gynecology?.mc?.note ? `- ${gynecology?.mc?.note}` : ''}
                </div>
              )}
            </Value>
          </li>
        )}
        {(gynecology?.mp || gynecology?.mcVal) && (
          <li className="mp-mc-history">
            <Row>
              <Col md={1} className="pr-0">
                <span className="border-bttom">MP</span>
              </Col>
              <Col md={1} className="pl-0 pr-0">
                <span className="colon-separator">:</span>
              </Col>
              <Col md={3} className="pl-0">
                <span
                  className={
                    gynecology?.mp &&
                    gynecology.mp.length > gynecology.mcVal.length
                      ? 'border-bttom'
                      : ''
                  }
                >
                  {gynecology?.mp} <span className="days">days</span>
                </span>
              </Col>
              <Col>
                <ChiefComplainDeleteBtn
                  action={clearData}
                  itemName={'mpMcVal'}
                  isDelBtn={isDelBtn}
                />
              </Col>
            </Row>
            <Row>
              <Col md={1} className="pr-0">
                MC
              </Col>
              <Col md={1} className="pl-0 pr-0"></Col>
              <Col md={3} className="pl-0">
                <span
                  className={
                    gynecology?.mp &&
                    gynecology?.mcVal &&
                    gynecology.mp.length <= gynecology.mcVal.length
                      ? 'bordertop'
                      : ''
                  }
                >
                  {gynecology?.mcVal}
                </span>
              </Col>
            </Row>
          </li>
        )}
        {(gynecology?.lmp || gynecology?.lmpNote) && (
          <li>
            {gynecology?.lmp && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="text-left" style={{ flex: 1 }}>
                  <Title>LMP:</Title>
                  <Value> {convertToDate(gynecology?.lmp)}</Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={clearData}
                  itemName={'lmp'}
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
            {gynecology?.lmp && gynecology?.lmpNote && (
              <Value>
                <div className="pl-4 font-italic">
                  {`- ${gynecology?.lmpNote}`}
                </div>
              </Value>
            )}
            {!gynecology?.lmp && gynecology?.lmpNote && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="text-left" style={{ flex: 1 }}>
                  <Title>LMP:</Title>
                  <Value> {gynecology?.lmpNote}</Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={clearData}
                  itemName={'lmp'}
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}
        {((gynecology?.edd && gynecology?.showEdd) || gynecology?.eddNote) && (
          <li>
            {gynecology?.edd && gynecology?.showEdd && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="text-left" style={{ flex: 1 }}>
                  <Title>EDD:</Title>
                  <Value> {convertToDate(gynecology?.edd)}</Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={clearData}
                  itemName={'edd'}
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
            {gynecology?.edd && gynecology?.eddNote && gynecology?.showEdd && (
              <Value>
                <div className="pl-4 font-italic">
                  {`- ${gynecology?.eddNote}`}
                </div>
              </Value>
            )}
            {!gynecology?.edd &&
              !gynecology?.showEdd &&
              gynecology?.eddNote && (
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                  <span className="text-left" style={{ flex: 1 }}>
                    <Title>EDD:</Title>
                    <Value> {gynecology?.eddNote}</Value>
                  </span>
                  <ChiefComplainDeleteBtn
                    action={clearData}
                    itemName={'edd'}
                    isDelBtn={isDelBtn}
                  />
                </div>
              )}
            {!gynecology?.edd && gynecology?.showEdd && gynecology?.eddNote && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="text-left" style={{ flex: 1 }}>
                  <Title>EDD:</Title>
                  <Value> {gynecology?.eddNote}</Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={clearData}
                  itemName={'edd'}
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
            {gynecology?.edd && !gynecology?.showEdd && gynecology?.eddNote && (
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span className="text-left" style={{ flex: 1 }}>
                  <Title>EDD:</Title>
                  <Value> {gynecology?.eddNote}</Value>
                </span>
                <ChiefComplainDeleteBtn
                  action={clearData}
                  itemName={'edd'}
                  isDelBtn={isDelBtn}
                />
              </div>
            )}
          </li>
        )}
      </ul>
      {(gynecology?.maritalStatus?.married ||
        gynecology?.maritalStatus?.unmarried ||
        gynecology?.maritalStatus?.divorce ||
        gynecology?.maritalStatus?.widow ||
        gynecology?.marriedFor?.years ||
        gynecology?.marriedFor?.months ||
        gynecology?.marriedFor?.days ||
        gynecology?.marriedFor?.hours ||
        gynecology?.familyPlanning?.husbandAbroad ||
        gynecology?.familyPlanning?.separated ||
        gynecology?.familyPlanning?.bilateralTubalLigation ||
        gynecology?.familyPlanning?.gravida ||
        gynecology?.familyPlanning?.separated ||
        gynecology?.familyPlanning?.separated ||
        gynecology?.paraFirst ||
        gynecology?.paraFirstSign ||
        gynecology?.paraSecond ||
        gynecology?.paraSecond ||
        gynecology?.paraThird ||
        gynecology?.paraThirdSign ||
        gynecology?.ageOfLastChild?.years ||
        gynecology?.ageOfLastChild?.months ||
        gynecology?.ageOfLastChild?.days ||
        gynecology?.ageOfLastChild?.hours) && (
        <div className="">Obstetrical History:</div>
      )}
      <ul>
        {(gynecology?.maritalStatus?.married ||
          gynecology?.maritalStatus?.unmarried ||
          gynecology?.maritalStatus?.divorce ||
          gynecology?.maritalStatus?.widow) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>Marital Status:</Title>
                {gynecology?.maritalStatus?.married && <Value> Married</Value>}
                {gynecology?.maritalStatus?.unmarried && (
                  <Value> Unmarried</Value>
                )}
                {gynecology?.maritalStatus?.divorce && <Value> Divorce</Value>}
                {gynecology?.maritalStatus?.widow && <Value> Widow</Value>}
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'maritalStatus'}
                isDelBtn={isDelBtn}
              />
            </div>
          </li>
        )}
        {(gynecology?.marriedFor?.years ||
          gynecology?.marriedFor?.months ||
          gynecology?.marriedFor?.days ||
          gynecology?.marriedFor?.hours) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>Marital For:</Title>
                {gynecology?.marriedFor?.years && (
                  <Value> {gynecology?.marriedFor?.years} Years </Value>
                )}
                {gynecology?.marriedFor?.months && (
                  <Value> {gynecology?.marriedFor?.months} Months </Value>
                )}
                {gynecology?.marriedFor?.days && (
                  <Value> {gynecology?.marriedFor?.days} Days </Value>
                )}
                {gynecology?.marriedFor?.hours && (
                  <Value> {gynecology?.marriedFor?.hours} Hours </Value>
                )}
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'marriedFor'}
                isDelBtn={isDelBtn}
              />
            </div>
          </li>
        )}
        {(gynecology?.familyPlanning?.husbandAbroad ||
          gynecology?.familyPlanning?.separated) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>Family Planning:</Title>
                {gynecology?.familyPlanning?.husbandAbroad && (
                  <Value> Husband Abroad</Value>
                )}
                {gynecology?.familyPlanning?.separated && (
                  <Value> Separated</Value>
                )}
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'familyPlanning'}
                isDelBtn={isDelBtn}
              />
            </div>
          </li>
        )}
        {(gynecology?.bilateralTubalLigation ||
          gynecology?.bilateralTubalLigation) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>Bilateral Tubal Ligation:</Title>
                {gynecology?.bilateralTubalLigation === 'Yes' && (
                  <Value> Yes </Value>
                )}
                {gynecology?.bilateralTubalLigation === 'No' && (
                  <Value> No </Value>
                )}
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'bilateralTubalLigation'}
                isDelBtn={isDelBtn}
              />
            </div>
          </li>
        )}
        {gynecology?.gravida && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>Gravida: {gynecology?.gravida}</Title>
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'gravida'}
                isDelBtn={isDelBtn}
              />
            </div>
            <Value>
              {gynecology?.gravidaNote && (
                <div className="pl-4 font-italic">
                  {gynecology?.gravidaNote
                    ? `- ${gynecology?.gravidaNote}`
                    : ''}
                </div>
              )}
            </Value>
          </li>
        )}
        {(gynecology?.paraFirst ||
          gynecology?.paraFirstSign ||
          gynecology?.paraSecond ||
          gynecology?.paraSecondSign ||
          gynecology?.paraThird ||
          gynecology?.paraThirdSign ||
          gynecology?.paraFourth ||
          gynecology?.paraFourthSign ||
          gynecology?.paraFifth) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>Para: </Title>
                {gynecology?.paraFirst || ''}{' '}
                {gynecology?.paraFirst && gynecology?.paraFirstSign
                  ? ` ${gynecology.paraFirstSign} `
                  : ''}
                {gynecology?.paraSecond || ''}{' '}
                {gynecology?.paraSecond && gynecology?.paraSecondSign
                  ? ` ${gynecology.paraSecondSign} `
                  : ''}
                {gynecology?.paraThird || ''}{' '}
                {gynecology?.paraThird && gynecology?.paraThirdSign
                  ? ` ${gynecology.paraThirdSign} `
                  : ''}
                {gynecology?.paraFourth || ''}{' '}
                {gynecology?.paraFourth && gynecology?.paraFourthSign
                  ? ` ${gynecology.paraFourthSign} `
                  : ''}
                {gynecology?.paraFifth || ''}{' '}
                <Value>
                  {gynecology?.paraNote ? `- ${gynecology?.paraNote}` : ''}
                </Value>
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'para'}
                isDelBtn={isDelBtn}
              />
            </div>
          </li>
        )}
        {(gynecology?.ageOfLastChild?.years ||
          gynecology?.ageOfLastChild?.months ||
          gynecology?.ageOfLastChild?.days ||
          gynecology?.ageOfLastChild?.hours) && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>Age Of Last Child:</Title>
                <Value>
                  {gynecology?.ageOfLastChild?.years && (
                    <span> {gynecology?.ageOfLastChild?.years} Years </span>
                  )}
                  {gynecology?.ageOfLastChild?.months && (
                    <span> {gynecology?.ageOfLastChild?.months} Months </span>
                  )}
                  {gynecology?.ageOfLastChild?.days && (
                    <span> {gynecology?.ageOfLastChild?.days} Days </span>
                  )}
                  {gynecology?.ageOfLastChild?.hours && (
                    <span> {gynecology?.ageOfLastChild?.hours} Hours </span>
                  )}
                </Value>
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'ageOfLastChild'}
                isDelBtn={isDelBtn}
              />
            </div>
            {gynecology?.ageOfLastChild?.note && (
              <div className="pl-4 font-italic">
                <Value>
                  {gynecology?.ageOfLastChild?.note
                    ? `- ${gynecology?.ageOfLastChild?.note}`
                    : ''}
                </Value>
              </div>
            )}
          </li>
        )}
      </ul>
      {(gynecology?.fp || gynecology?.fpNote) && (
        <div className="">Contraceptive Method:</div>
      )}
      <ul>
        {gynecology?.fp && (
          <li>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <span className="text-left" style={{ flex: 1 }}>
                <Title>FP:</Title>
                <Value> {gynecology?.fp}</Value>
              </span>
              <ChiefComplainDeleteBtn
                action={clearData}
                itemName={'fp'}
                isDelBtn={isDelBtn}
              />
            </div>
            {gynecology?.fpNote && (
              <div className="pl-4 font-italic">
                <Value>
                  {gynecology?.fpNote ? `- ${gynecology?.fpNote}` : ''}
                </Value>
              </div>
            )}
          </li>
        )}
      </ul>
    </div>
  );
};

export default memo(Gynecology);
